import { IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { LeavesDTO } from "./leaves.dto";

export class EmpLeaveDTO {
    @ApiProperty()
    @IsNotEmpty()
    employeeId: number; 
    @ApiProperty()
    employeeCode:string;
    @ApiProperty()
    employeeName: string;
    @ApiProperty()
    employeeLastName: string;
    @ApiProperty()
    designation:string;
    @ApiProperty()
    status:string;
    @ApiProperty()
    departmentId:string;
    @IsNotEmpty()
    year: string;
    @ApiProperty({ type: () => [LeavesDTO] })
    @IsNotEmpty()
    leaves: LeavesDTO[]
    @ApiProperty()
    gender?:string;
    @ApiProperty()
    departmentName?:string;
}